import React, { useEffect, useState } from 'react'
import {
  Container,
  RedirectButtons,
  BackButtonNavbar,
  JoinUsDiv,
  ContentPointDiv,
  ContentPointsIcon,
  ContentPoint,
  CTAHelperText,
  PolicyDisclaimer,
  HeroBannerImg,
  WelcomeText,
  LoaderDiv,
} from './styles'
import ArrowLeft from '../Images/ArrowLeft'
import Pen from './nibpen_alt.svg'
import Dollar from './dollar.svg'
import Audiance from './audiance.svg'
import HeroBanner from './heroBanner.svg'
import { get } from '../../lib/api'
import Loader from '../Loader'
import {
  handleEventLog,
  handlePageLoadEventLog,
  saveSession,
} from '../../lib/utils'
import { set } from '../../lib/storage'

function Onboarding({ history, location, match }) {
  const isMobile = window.innerWidth < 900
  const query = new URLSearchParams(window.location.search)
  const mail = query.get('email')
  const uid = query.get('uid')
  const token = query.get('token')
  const origin = query.get('origin')
  const userTag = query.get('user_tag')
  const redirectTo = query.get('redirect_to')

  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState(mail)
  const [authorName, setAuthorName] = useState('')
  const [loginStateAvailable, setLoginStateAvailable] = useState('')

  useEffect(() => {
    handlePageLoadEventLog('Onboarding', {
      entity_id: uid || ''
    })
    // setting flow in local storage
    set('ugc', 'true')

    // setting referrer in local storage
    if (origin && origin.toLowerCase().includes('pfm_android')) {
      localStorage.setItem('referrer', `pfm_android_PWA_US`)
    } else if (origin && origin.toLowerCase().includes('pfm_ios')) {
      localStorage.setItem('referrer', `pfm_IOS_PWA_US`)
    } else if (origin && origin.toLowerCase().includes('android')) {
      localStorage.setItem(
        'referrer',
        `android_PWA_US${userTag ? '_' : ''}${userTag || ''}`
      )
    } else if (origin && origin.toLowerCase().includes('ios')) {
      localStorage.setItem(
        'referrer',
        `IOS_PWA_US${userTag ? '_' : ''}${userTag || ''}`
      )
    }
    // checking for auto login capability
    if (uid && token) {
      setLoading(true)
      get('/user_api/user.get_creator_details?is_novel=1', {
        headers: {
          'access-token': token,
          uid: uid,
        },
      })
        .then((res) => {
          setLoading(false)
          const { result } = res
          if (result.creator_alias) {
            setEmail(result.email)
            setLoginStateAvailable('auto_login')
            const { fullname, image_url, uid } = result
            const sessionInfo = {
              name: fullname,
              token,
              image_url,
              uid,
            }
            setAuthorName(fullname)
            saveSession(sessionInfo)
            if (localStorage.getItem('isLoggedIn') === 'true') {
              if (redirectTo) history.push(redirectTo)
              else history.push('/home#redirectFromLogin')
            }
            handlePageLoadEventLog('Welcome Back', {
              entity_id: uid,
            })
          } else {
            // if user exists but not yet have a creator account
            setLoginStateAvailable('register')
          }
        })
        .catch((err) => {
          setLoginStateAvailable('login_signup')
          console.log(err)
          setLoading(false)
        })
    } else {
      setLoginStateAvailable('login_signup')
      handlePageLoadEventLog('Welcome')
    }
  }, [])

  const redirect = (to) => {
    if (to === 'home') {
      handleEventLog('onboarding', 'button_click', {
        module_name: 'EASY LOGIN',
      })
      history.push(`/home#redirectFromLogin`)
    }
    if (to === 'register') {
      handleEventLog('onboarding', 'button_click', {
        module_name: 'EASY SIGNUP',
      })
      history.push(
        `/globalLogin${location.search}&view=register`
      )
    }
    if (to === 'globalLogin') {
      handleEventLog('onboarding', 'button_click', {
        module_name: 'SIGN UP / LOGIN via New Account',
      })
      history.push(`/globalLogin?view=login`)
    }
  }

  const maskEmail = (email) => {
    if (!email) return ''
    const atIndex = email.indexOf('@')
    if (atIndex >= 4) {
      const username = email.substring(0, 4) + 'x'.repeat(atIndex - 3)
      const domain = email.substring(atIndex+1)
      return username + domain
    } else {
      return email
    }
  }

  const backPressed = () => {
    if (window.Android) {
      if (window.Android.onBackPressed) {
        console.log('Executed onBackPressed')
        window.Android.onBackPressed()
      }
    } else {
      console.log('Function onBackPressed not exist')
    }
    if (window.webkit) {
      if (window.webkit.messageHandlers) {
        console.log('inside webkit.onBackPressed')
        window.webkit.messageHandlers.onBackPressed.postMessage({})
      }
    }
  }

  if (loading) {
    return (
      <Container>
        <LoaderDiv>
          <Loader />
        </LoaderDiv>
      </Container>
    )
  }

  return (
    <Container>
      <BackButtonNavbar>
        <ArrowLeft onClick={() => backPressed()} />{' '}
        <img src="/images/writer-logo.svg" alt="" />
      </BackButtonNavbar>
      {loginStateAvailable === 'auto_login' && (
        <HeroBannerImg>
          <img src={HeroBanner} alt="" />
        </HeroBannerImg>
      )}
      {loginStateAvailable === 'auto_login' && !loading && (
        <WelcomeText>Welcome Back {authorName}</WelcomeText>
      )}
      {loginStateAvailable !== 'auto_login' && (
        <JoinUsDiv>
          <h2>Join Us</h2>
          <p>
            Want to share your story on Pocket FM?
            <br /> Start Now!
          </p>
          <ContentPointDiv>
            <ContentPointsIcon>
              {' '}
              <img src={Pen} alt="" />{' '}
            </ContentPointsIcon>
            <ContentPoint>
              <b>Write</b> your original story & create audio series using AI
              technology
            </ContentPoint>
          </ContentPointDiv>
          <ContentPointDiv>
            <ContentPointsIcon>
              {' '}
              <img src={Audiance} alt="" />{' '}
            </ContentPointsIcon>
            <ContentPoint>
              <b>Showcase</b> your audio series to millions of users
            </ContentPoint>
          </ContentPointDiv>
          <ContentPointDiv>
            <ContentPointsIcon>
              {' '}
              <img src={Dollar} alt="" />{' '}
            </ContentPointsIcon>
            <ContentPoint>
              <b>Earn</b> revenue share & other bonuses with our Writer Benefit
              Program
            </ContentPoint>
          </ContentPointDiv>
        </JoinUsDiv>
      )}
      {loginStateAvailable !== 'auto_login' && (
        <CTAHelperText>
          Ready to embark on your creative adventure? Sign Up to get started and
          become a part of something extraordinary!
        </CTAHelperText>
      )}
      {loginStateAvailable === 'auto_login' && (
        <CTAHelperText lightText>
          Your creativity & talent make our community shine. As you log in,
          remember that your creations are at the heart of what we do
        </CTAHelperText>
      )}
      {loginStateAvailable === 'auto_login' && (
        <RedirectButtons onClick={() => redirect('home')} highlight>
          EASY LOGIN via {maskEmail(email)}
        </RedirectButtons>
      )}
      {loginStateAvailable === 'register' && (
        <RedirectButtons onClick={() => redirect('register')} highlight>
          EASY SIGNUP via {maskEmail(email)}
        </RedirectButtons>
      )}
      <RedirectButtons
        onClick={() => redirect('globalLogin')}
        highlight={loginStateAvailable === 'login_signup'}
      >
        SIGN UP / LOGIN via New Account
      </RedirectButtons>{' '}
      <PolicyDisclaimer>
        By signing up or logging in, you accept the{' '}
        <a href="https://pocketfm.com/us/terms-and-conditions" target="_blank">
          Terms of Use
        </a>{' '}
        and{' '}
        <a href="https://pocketfm.com/us/privacy-policy" target="_blank">
          Privacy Policy
        </a>
      </PolicyDisclaimer>
    </Container>
  )
}

export default Onboarding
